<template>

  <l-table
    ref="researchAdvisorTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #create-body>
      <b-button
        v-if="canCreate()"
        variant="primary"
        @click="$router.push({ name: 'research-advisor-add'})"
      >
        {{ $t('Add Advisor') }}
      </b-button>
    </template>
    <template
      v-for="cell in cellSlotNames"
      #[cell]="{ data }"
    >
      {{ data.field.key in data.item.user ? data.item.user[data.field.key] : data.item[data.field.key] }}
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-if="canUpdate(data.item)"
          icon="EditIcon"
          class="mr-1 cursor-pointer"
          size="16"
          @click="$router.push({ name: 'research-advisor-update', params: { id: data.item.id }})"
        />

        <feather-icon
          icon="EyeIcon"
          class="mr-1 cursor-pointer"
          size="16"
          @click="$router.push({ name: 'research-advisor-view', params: { id: data.item.id }})"
        />

        <feather-icon
          v-if="canDelete(data.item)"
          :id="`invoice-row-${data.item.id}-preview-icon`"
          icon="TrashIcon"
          size="16"
          class="mr-1 cursor-pointer"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import researchAdvisorModule from '@/store/research-advisor/index'
import permission from '@/views/pages/research-advisor/permission'
import LTable from '@/views/components/LTable.vue'
import ResearchAdvisor from '@/views/components/filters/service/ResearchAdvisor'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
  },
  computed: {
    cellSlotNames() {
      return this.tableColumns.map(item => `cell(${item.key})`)
    },
  },
  created() {
    this.$store.dispatch('staticModule/universityList')
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    const filterClass = new ResearchAdvisor()
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, researchAdvisorModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
      ...config(),
      ...permission(),
      filterClass,
    }
  },
}
</script>
